import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";

import { MemberInfo } from "../Creation/CreateGroupForm";

interface DeleteConfirmationProps {
  deleteConfirmOpen: boolean;
  setDeleteConfirmOpen: (open: boolean) => void;
  onConfirm: () => void;
  user: MemberInfo;
}

const DeleteConfirmation: React.FC<DeleteConfirmationProps> = ({
  deleteConfirmOpen,
  setDeleteConfirmOpen,
  onConfirm,
  user,
}) => {
  return (
    <Dialog
      open={deleteConfirmOpen}
      aria-labelledby="delete-dialog-title"
      aria-describedby="delete-dialog-description"
    >
      <DialogTitle id="delete-dialog-title">Remove Member</DialogTitle>
      <DialogContent>
        <DialogContentText id="delete-dialog-description">
          Are you sure you want to remove{" "}
          <strong>
            {user?.firstName} {user.lastName}
          </strong>{" "}
          from the rotation schedule? This action cannot be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setDeleteConfirmOpen(false)} color="inherit">
          Cancel
        </Button>
        <Button onClick={onConfirm} color="error" variant="contained" autoFocus>
          Remove
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmation;
